// extracted by mini-css-extract-plugin
export default {"circle":"_1v3tlkFbBotuF5UUiMcy64","text":"_12spHuUsJQFp496TwN7fnt","customTooltip":"_2fwDxaM-NmxeCtc4gkdQVM"};